import { useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Merchant } from "@/types";

type Props = {
  merchant?: Merchant;
};

export function MerchantForm({ merchant }: Props) {
  const { data, setData, post, patch, processing, errors, transform } = useForm(
    {
      name: merchant?.name ?? "",
    },
  );

  transform((data) => {
    return { merchant: data };
  });

  function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();

    if (merchant) {
      patch(`/merchants/${merchant.id}`, {
        preserveScroll: "errors",
      });
    } else {
      post("/merchants", {
        preserveScroll: "errors",
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="merchant_name">Name</Label>
        <Input
          id="merchant_name"
          name="name"
          value={data.name}
          onChange={(e) => setData("name", e.target.value)}
          aria-invalid={!!errors.name}
        />
        {errors.name && (
          <p className="text-destructive text-sm">{errors.name}</p>
        )}
      </div>
      <div className="flex justify-end">
        <Button type="submit" disabled={processing}>
          {merchant ? "Update merchant" : "Create merchant"}
        </Button>
      </div>
    </form>
  );
}
